var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "129px",
    height: "129px",
    viewBox: "0 0 129 129",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "info") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.5,0 C100.122366,0 129,28.8776336 129,64.5 C129,100.122366 100.122366,129 64.5,129 C28.8776336,129 0,100.122366 0,64.5 C0,28.8776336 28.8776336,0 64.5,0 Z M64.5,10.5 C34.6766235,10.5 10.5,34.6766235 10.5,64.5 C10.5,94.3233765 34.6766235,118.5 64.5,118.5 C94.3233765,118.5 118.5,94.3233765 118.5,64.5 C118.5,34.6766235 94.3233765,10.5 64.5,10.5 Z M71,54 C72.1045695,54 73,54.8954305 73,56 L73,100 C73,101.104569 72.1045695,102 71,102 L58,102 C56.8954305,102 56,101.104569 56,100 L56,56 C56,54.8954305 56.8954305,54 58,54 L71,54 Z M64.5,28 C69.1944204,28 73,31.8055796 73,36.5 C73,41.1944204 69.1944204,45 64.5,45 C59.8055796,45 56,41.1944204 56,36.5 C56,31.8055796 59.8055796,28 64.5,28 Z",
    id: "info",
    fill: "#7C7C7C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.06ae504f3a0628477239e2c7d298537d.svg";
export { ForwardRef as ReactComponent };